import { render, staticRenderFns } from "./create-quiz.html?vue&type=template&id=d2cfe45a&scoped=true&"
import script from "./create-quiz.vue?vue&type=script&lang=js&"
export * from "./create-quiz.vue?vue&type=script&lang=js&"
import style0 from "./create-quiz.css?vue&type=style&index=0&id=d2cfe45a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2cfe45a",
  null
  
)

export default component.exports